module.exports = __webpack_public_path__ + "static/ela-dc53b66de18408311a747217a638a003.jpg";